<div class="storage-full tw-pt-8">
  <files-list
    [isListView]="isListView"
    (isListViewChange)="isListViewChange($event)"
    [selectorType]="StorageUtilsService.SELECTOR_TYPES.MULTIPLE_FILES_FOLDERS"
    [selectorFilter]="StorageUtilsService.SELECTOR_FILTERS.ALL"
    [storageFull]="true"
  ></files-list>
</div>
